import Commerce from "@chec/commerce.js"


const commerce = new Commerce('pk_test_49064b2ce84c0d4b3d3a619ed7cac83d6f0a95c18dadd');

export default commerce